import { Logo } from '../components/Logo.js';
import { Spinner } from '../components/Spinner.js';

export function LoadingScreen({ text }: { text: string }) {
  return (
    <div className="bg-hero grid h-full place-items-center">
      <div className="anim-slide-up flex flex-col items-center gap-5 text-center">
        <Logo size={56} withGlow />
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Wo Ist?</h1>
          <p className="mt-1 text-sm text-muted">Finde Orte mit Freunden im Voice-Channel.</p>
        </div>
        <div className="mt-2 flex items-center gap-3 text-muted">
          <Spinner size={20} />
          <span className="text-[13px]">{text}</span>
        </div>
      </div>
    </div>
  );
}
